import Select from "../../../ui/Select/Select";
import countryOptions from "./country-options";
import styles from "./CountryLanguageSelect.module.scss";

function CountryLanguageSelect({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <Select
      className={styles.select}
      size="xsmall"
      value={value}
      onChange={(value) => onChange(value ?? "us:en")}
      data={countryOptions}
      useShortLabels
      matchWidth={false}
    />
  );
}

export default CountryLanguageSelect;
